import type { CertificateLang } from "./certificate-lang";

// Intl locales matching each certificate language. English keeps the
// historical "23 June 2026" (en-GB) look; Arabic uses Latin digits to match
// the rest of the certificate (IDs, course length).
const DATE_LOCALES: Record<CertificateLang, string> = {
    en: "en-GB",
    es: "es-ES",
    de: "de-DE",
    fr: "fr-FR",
    it: "it-IT",
    ja: "ja-JP",
    pt: "pt-BR",
    ar: "ar-u-nu-latn"
};

// Renders dates the same way course certificates do, e.g. "23 June 2026".
// The Arabic date is wrapped in a right-to-left isolate (RLI … PDI): the
// certificate image is an SVG whose text runs left-to-right, and there
// "1 سبتمبر 2026" came out with the day glued to the year ("1 2026 سبتمبر").
export function formatCertificateDate(input?: string | number | Date | null, lang: CertificateLang = "en"): string {
    const date = input ? new Date(input) : new Date();
    if (Number.isNaN(date.getTime())) {
        return typeof input === "string" ? input : "";
    }
    const formatted = date.toLocaleDateString(DATE_LOCALES[lang], { day: "numeric", month: "long", year: "numeric" });
    return lang === "ar" ? `\u2067${formatted}\u2069` : formatted;
}
